import React from 'react'
import toastr from 'toastr'
import { formatUserName } from './adminUsersUtils'

export default function AdminUserModals({
  showResetModal,
  resetUser,
  tempPassword,
  onCloseResetModal,
  onGeneratePassword,
  showMakeAdminModal,
  userToMakeAdmin,
  onCloseMakeAdminModal,
  onConfirmMakeAdmin,
  showImpersonateModal,
  impersonateTarget,
  impersonateReason,
  setImpersonateReason,
  impersonating,
  onCloseImpersonateModal,
  onConfirmImpersonate,
}) {
  return (
    <>
      {showResetModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'var(--fl-shadow-modal-backdrop)',
            zIndex: 3000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              background: 'var(--fl-theme-background)',
              borderRadius: 12,
              boxShadow: '0 4px 24px var(--fl-shadow-modal-elevated)',
              minWidth: 320,
              maxWidth: 400,
              width: '100%',
              padding: 24,
              position: 'relative',
            }}
          >
            <button
              onClick={onCloseResetModal}
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                background: 'none',
                border: 'none',
                fontSize: 22,
                color: 'var(--fl-text-tertiary)',
                cursor: 'pointer',
              }}
              aria-label="Close"
            >
              ×
            </button>
            <h5>Reset Password for {resetUser?.email}</h5>
            <p>
              Would you like to generate a new temporary password for this user?
            </p>
            {!tempPassword ? (
              <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                <button
                  className="btn btn-primary"
                  onClick={onGeneratePassword}
                >
                  Generate Password
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={onCloseResetModal}
                >
                  Cancel
                </button>
              </div>
            ) : (
              <div style={{ marginTop: 12 }}>
                <label>Temporary Password:</label>
                <div
                  style={{
                    display: 'flex',
                    gap: 8,
                    alignItems: 'center',
                    marginTop: 4,
                  }}
                >
                  <input
                    type="text"
                    className="form-control"
                    value={tempPassword}
                    readOnly
                    style={{ fontFamily: 'monospace' }}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      navigator.clipboard.writeText(tempPassword)
                      toastr.success('Copied to clipboard!')
                    }}
                  >
                    Copy
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={onCloseResetModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showMakeAdminModal && userToMakeAdmin && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'var(--fl-shadow-modal-backdrop)',
            zIndex: 3000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={onCloseMakeAdminModal}
        >
          <div
            style={{
              background: 'var(--fl-theme-background)',
              borderRadius: 12,
              boxShadow: '0 4px 24px var(--fl-shadow-modal-elevated)',
              minWidth: 320,
              maxWidth: 500,
              width: '100%',
              padding: 24,
              position: 'relative',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={onCloseMakeAdminModal}
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                background: 'none',
                border: 'none',
                fontSize: 22,
                color: 'var(--fl-text-tertiary)',
                cursor: 'pointer',
              }}
              aria-label="Close"
            >
              ×
            </button>
            <h5 style={{ marginBottom: 16 }}>⚠️ Confirm Admin Promotion</h5>
            <div
              className="alert alert-warning"
              style={{ marginBottom: 16, padding: 12 }}
            >
              <strong>Are you sure?</strong>
            </div>
            <p style={{ marginBottom: 12 }}>
              You are about to promote{' '}
              <strong>{formatUserName(userToMakeAdmin)}</strong> (
              {userToMakeAdmin.email}) to an admin role.
            </p>
            <p style={{ marginBottom: 12 }}>Admins will have the ability to:</p>
            <ul style={{ marginBottom: 16, paddingLeft: 20 }}>
              <li>Manage users and leagues</li>
              <li>Access administrative tools</li>
              <li>Modify system settings</li>
              <li>View sensitive information</li>
            </ul>
            <div
              className="alert alert-info"
              style={{ padding: 12, fontSize: '0.875rem' }}
            >
              <strong>Note:</strong> This action can be reversed by changing the
              user's role back to "player" in the user management panel.
            </div>
            <div
              style={{
                display: 'flex',
                gap: 8,
                marginTop: 16,
                justifyContent: 'flex-end',
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={onCloseMakeAdminModal}
              >
                Cancel
              </button>
              <button className="btn btn-primary" onClick={onConfirmMakeAdmin}>
                Confirm - Make Admin
              </button>
            </div>
          </div>
        </div>
      )}

      {showImpersonateModal && impersonateTarget && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'var(--fl-shadow-modal-backdrop)',
            zIndex: 3000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={onCloseImpersonateModal}
          onKeyDown={(e) => {
            if (e.key === 'Escape') onCloseImpersonateModal()
          }}
        >
          <div
            style={{
              background: 'var(--fl-theme-background)',
              borderRadius: 12,
              boxShadow: '0 4px 24px var(--fl-shadow-modal-elevated)',
              minWidth: 320,
              maxWidth: 500,
              width: '100%',
              padding: 24,
              position: 'relative',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={onCloseImpersonateModal}
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                background: 'none',
                border: 'none',
                fontSize: 22,
                color: 'var(--fl-text-tertiary)',
                cursor: 'pointer',
              }}
              aria-label="Close"
            >
              ×
            </button>
            <h5 style={{ marginBottom: 16 }}>🔐 Impersonate User</h5>
            <div
              className="alert alert-warning"
              style={{ marginBottom: 16, padding: 12 }}
            >
              <strong>This action will be logged for audit purposes.</strong>
            </div>
            <p style={{ marginBottom: 12 }}>
              You are about to log in as{' '}
              <strong>{formatUserName(impersonateTarget)}</strong> (
              {impersonateTarget.email}).
            </p>
            <div style={{ marginBottom: 16 }}>
              <label
                htmlFor="impersonate-reason"
                style={{ marginBottom: 8, display: 'block', fontWeight: 500 }}
              >
                Reason for impersonation:{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
              <textarea
                id="impersonate-reason"
                className="form-control"
                rows="3"
                placeholder="e.g., Troubleshooting login issues reported by user"
                value={impersonateReason}
                onChange={(e) => setImpersonateReason(e.target.value)}
                disabled={impersonating}
                style={{ resize: 'vertical' }}
                data-testid="impersonate-reason-input"
                maxLength={500}
              />
              <small
                className="text-muted"
                style={{ marginTop: 4, display: 'block' }}
              >
                Please provide a detailed reason for this impersonation. This
                will be logged.
              </small>
            </div>
            <div
              style={{
                display: 'flex',
                gap: 8,
                marginTop: 16,
                justifyContent: 'flex-end',
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={onCloseImpersonateModal}
                disabled={impersonating}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={onConfirmImpersonate}
                disabled={impersonating || !impersonateReason.trim()}
                data-testid="impersonate-confirm-button"
              >
                {impersonating ? 'Processing...' : 'Confirm Impersonation'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
